var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"handsonTable-wrapper"},[_c('HotTable',_vm._b({key:_vm.tableId,ref:"theTable",staticClass:"hot handsontable htRowHeaders htColumnHeaders",staticStyle:{"height":"800px","overflow":"hidden"},attrs:{"data-originalstyle":"height: 800px; overflow: hidden; "}},'HotTable',_vm.dataTable,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }